import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisabledCondition from "../../../../../service/getDisabledCondition"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidResistColor from "../../../../service/visibleValidator/isValidResistColor"

import 黒 from "../../../../img/color/black.png"
import 青 from "../../../../img/color/blue.png"
import 緑 from "../../../../img/color/green.png"
import つや消し from "../../../../img/color/matteBlack.png"
import 紫 from "../../../../img/color/purple.png"
import 赤 from "../../../../img/color/red.png"
import 白 from "../../../../img/color/white.png"
import 黄 from "../../../../img/color/yellow.png"

const レジスト色 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { resistColor: shouldShow } = getDisplayCondition(values)
  const disabled = getDisabledCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      disabled={disabled.resistColor}
      legend="レジスト色"
      helpURL={HELP_LINKS.レジスト色}
    >
      <RadioGroup
        name={FIELD_NAMES.レジスト色}
        selectedValue={values.resistColor}
        onChange={handlers.radio}
        disabled={disabled.resistColor}
        shouldRender={(value) => isValidResistColor(values, value)}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["緑(リジッド)"].value} prefixImageSrc={緑}>
            緑
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["赤(リジッド)"].value} prefixImageSrc={赤}>
            赤
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["青(リジッド)"].value} prefixImageSrc={青}>
            青
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["黄(リジッド)"].value} prefixImageSrc={黄}>
            黄
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["白(リジッド)"].value} prefixImageSrc={白}>
            白
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["黒(リジッド)"].value} prefixImageSrc={黒}>
            黒
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["黒（つや消し）(リジッド)"].value} prefixImageSrc={つや消し}>
            黒（つや消し）
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色.紫.value} prefixImageSrc={紫}>
            紫
          </Radio>

          <Radio value={ESTIMATE_CONSTANT.レジスト色["緑(メタル)"].value} prefixImageSrc={緑}>
            緑
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["赤(メタル)"].value} prefixImageSrc={赤}>
            赤
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["青(メタル)"].value} prefixImageSrc={青}>
            青
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["黄(メタル)"].value} prefixImageSrc={黄}>
            黄
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["白(メタル)"].value} prefixImageSrc={白}>
            白
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["黒(メタル)"].value} prefixImageSrc={黒}>
            黒
          </Radio>
          <Radio value={ESTIMATE_CONSTANT.レジスト色["黒（つや消し）(メタル)"].value} prefixImageSrc={つや消し}>
            黒（つや消し）
          </Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.resistColor} />
    </OneClickField>
  )
}

export default レジスト色
